<template>

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody />



        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody />


            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content">

                <div class="row mb-32 gy-16 dash-top" style="padding-bottom: 500px;">

                    <!-- BANNER -->
                    <div class="col-12 " style="margin-top: -10px;">

                        <!-- MAIN BALANCE -->
                        <div class="hp-bg-black-b   position-relative overflow-hidden hp-page-content pBack1" style="border-radius: 20px; background-size: cover; " >

                            <div class="row">
                                
                                <div class="col-sm-12">

                                    <div class="car" >
                                        <div class="card-body ">

                                            <div class="row">

                                                <div class="col-12">

                                                    <div class="mm-none">

                                                        <div  style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 0px 50px; margin-bottom: 20px;">
                                                        

                                                        <div>
                                                            <p class="hp-p1-body mb-0 text-black-60 hp-text-color-dark-30">Total Earnings</p>
                                                            <h1 class="mb-4 mt-8" style="font-size: 50px; color: #fff;"> <span>&#8358;</span>  {{ earningsD }} </h1>

                                                        </div>

                                                        <div >
                                                            <button  @click="withdrawClick" class="btn btn-primary " style=" color: #fff;  margin-right: 20px; margin-top: 50px; margin-bottom: 20px; margin-left: -60px;">

                                                                <i class="hp-text-color-dark-0 iconly-Light-ArrowUpSquare" ></i>
                                                                <span style="padding-left: 10px;">Withdraw</span>

                                                            </button>
                                                        </div>

                                                        

                                                    </div>

                                                    </div>

                                                    <div class="dd-none" style=" justify-content: space-between; align-items: center; width: 100%; padding: 0px 10px; margin-bottom: 20px;">
                                                        

                                                        <div>
                                                            <p class="hp-p1-body mb-0 text-black-60 hp-text-color-dark-30 mt-24">Total Earnings</p>
                                                            <h1 class="mb-4 mt-16" style="font-size: 36px; color: #fff;"> <span>&#8358;</span>  {{ earningsD }} </h1>
                                                            

                                                            

                                                        </div>

                                                        <div >
                                                            <button  @click="withdrawClick" class="btn btn-primary " style=" color: #fff;  margin-right: 20px; margin-top: 50px; margin-bottom: 20px;">

                                                                <i class="hp-text-color-dark-0 iconly-Light-ArrowUpSquare" ></i>
                                                                <span style="padding-left: 10px;">Withdraw</span>

                                                            </button>
                                                        </div>

                                                        

                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    
                                </div>

                            </div>
                            
                        </div>

                        <!-- SUB BALANCES -->
                        <div class="col-12 mt-16 mm-none" v-if="userType=='model'">
                            <div class="col-sm-12" >

                                    <div class="row g-32 mb-32" >

                                        <div class="col-12 col-md-6 col-xl-4 ">
                                            <div class="card">
                                                <div class="card-body ">
                                                    <div class="row g-16">
                                                        <div class="col-6 hp-flex-none w-auto">
                                                            <div class="avatar-item d-flex align-items-center justify-content-center avatar-lg bg-primary-4 hp-bg-color-dark-primary rounded-circle">
                                                                <i class="ri-file-list-2-line text-primary-2 hp-text-color-dark-primary-3" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>

                                                        <div class="col">
                                                            <h3 class="mb-4 mt-8"> <span>&#8358;</span> {{ ppvBalanceD }} </h3>
                                                            <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">Paid posts</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6 col-xl-4" >
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row g-16">
                                                        <div class="col-6 hp-flex-none w-auto">
                                                            <div class="avatar-item d-flex align-items-center justify-content-center avatar-lg bg-secondary-4 hp-bg-color-dark-secondary rounded-circle">
                                                                <i class="ri-heart-line text-secondary-2" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>

                                                        <div class="col">
                                                            <h3 class="mb-4 mt-8"> <span>&#8358;</span> {{ subBalanceD }} </h3>
                                                            <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">Subscriptions</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6 col-xl-4">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row g-16">
                                                        <div class="col-6 hp-flex-none w-auto">
                                                            <div class="avatar-item d-flex align-items-center justify-content-center avatar-lg bg-warning-4 hp-bg-color-dark-warning rounded-circle"> 
                                                                <i class="ri-thumb-up-line text-warning" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>

                                                        <div class="col">
                                                            <h3 class="mb-4 mt-8"> <span>&#8358;</span> {{ tipBalanceD }} </h3>
                                                            <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">Tips</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                        </div>

                        <div class="col-12 mt-16 dd-none" v-if="userType=='model'">
                            <div class="col-sm-12" >

                                    <div class="row g-16 mb-32" >

                                        <div class="col-12 col-md-6 col-xl-4 ">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row g-16">
                                                        <div class="col-6 hp-flex-none w-auto">
                                                            <div class="avatar-item d-flex align-items-center justify-content-center avatar-lg bg-primary-4 hp-bg-color-dark-primary rounded-circle">
                                                                <i class="ri-file-list-2-line text-primary-2 hp-text-color-dark-primary-3" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>

                                                        <div class="col">
                                                            <h3 class="mb-4 mt-8"> <span>&#8358;</span> {{ ppvBalanceD }} </h3>
                                                            <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">Paid posts</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6 col-xl-4" >
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row g-16">
                                                        <div class="col-6 hp-flex-none w-auto">
                                                            <div class="avatar-item d-flex align-items-center justify-content-center avatar-lg bg-secondary-4 hp-bg-color-dark-secondary rounded-circle">
                                                                <i class="ri-heart-line text-secondary-2" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>

                                                        <div class="col">
                                                            <h3 class="mb-4 mt-8"> <span>&#8358;</span> {{ subBalanceD }} </h3>
                                                            <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">Subscriptions</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6 col-xl-4">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row g-16">
                                                        <div class="col-6 hp-flex-none w-auto">
                                                            <div class="avatar-item d-flex align-items-center justify-content-center avatar-lg bg-warning-4 hp-bg-color-dark-warning rounded-circle"> 
                                                                <i class="ri-thumb-up-line text-warning" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>

                                                        <div class="col">
                                                            <h3 class="mb-4 mt-8"> <span>&#8358;</span> {{ tipBalanceD }} </h3>
                                                            <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">Tips</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                        </div>

                    </div>

                    

                    <!-- POSTS -->
                    <div class="col-12">

                        <div class="row g-32">

                            <div class="col-12 col-xl-12">

                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link active" id="deposit-tab" data-bs-toggle="tab"
                                            data-bs-target="#deposit" role="tab" aria-controls="deposit"
                                            aria-selected="true" style="cursor: pointer;"> Earnings </h6>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link " id="withdrawal-tab" data-bs-toggle="tab"
                                            data-bs-target="#withdrawal" role="tab" aria-controls="withdrawal"
                                            aria-selected="false" style="cursor: pointer;"> Withdrawals </h6>
                                    </li>

                                </ul>

                                <!-- TAB CONTENT -->
                                <div class="tab-content">

                                    <!-- DEPOSITS -->
                                    <div class="tab-pane fade show active" id="deposit" role="tabpanel"
                                        aria-labelledby="deposit-tab">

                                        

                                        <!-- DUPLI -->
                                        <div class="card hp-project-ecommerce-table-card"
                                            style="margin-bottom: 10px; border-radius: 10px;"
                                            v-for="(tran, index) in transListD" :key="'number' + index">
                                            <div class="card-body ">

                                                <div class="row" v-if="tran.type == 'Deposit'">

                                                    <div class="col-12">

                                                        <div class="row g-32 ">

                                                            <div class="col-12 col-sm-3 ">

                                                                <div class="row gx-8 gy-16">

                                                                    <div
                                                                        style="display: flex; justify-content: flex-start; align-items: flex-start; cursor: pointer;">

                                                                        <div class="col hp-flex-none w-auto">

                                                                            <img :src="tran.profilePic"
                                                                                style="width: 58px; height: 58px; border-radius: 50%;   object-fit: cover; margin-right: 5px; border-color: #000; border-width: 1px; border-style: solid; margin-top: -10px;">

                                                                        </div>


                                                                        <div class="col hp-flex-none w-auto">
                                                                            <!-- <h6 class="mb-4 " style="width: 60%; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ tran.fullname }}</h6> -->
                                                                            <h6 class="mb-4 ">{{ tran.fullname }}</h6>
                                                                            <p
                                                                                class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                                @{{ tran.username }}
                                                                            </p>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4">{{ tran.title }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Title
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 tba">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"><span>&#8358;</span> {{
                                                                            tran.amountD }} </strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Amount
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-7 col-sm-3">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">

                                                                        <strong class="mb-4 dd-none">{{
                                                                            tran.dateD}}</strong>
                                                                        <strong class="mb-4 mm-none">{{
                                                                            tran.dateFull}}</strong>

                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Date and time
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                            <div class="col-5 col-sm-2">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong v-if="tran.status == 'successful'"
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-12 px-24 fw-medium ">
                                                                            Successful </strong>

                                                                        <strong v-else-if="tran.status == 'failed'"
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-12 px-24 fw-medium ">
                                                                            Failed </strong>

                                                                        <strong v-else style="font-size: 14px;"
                                                                            class="badge bg-warning-4 hp-bg-dark-warning text-warning border-none w-auto py-12 px-24 fw-medium ">
                                                                            Pending </strong>


                                                                    </div>


                                                                </div>
                                                            </div>



                                                            <!-- <div class="col-6 col-sm-1" >
                                                                <div class="row gx-8 gy-16" >
                                                                    
                                                                    <div class="col hp-flex-none w-auto">
                                                                        <button class="btn btn-icon-only rounded-circle btn-outline-primary" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#info">
                                                                            <i class="hp-text-color-dark-0 ri-2 ri-more-line" style="font-size: 24px; font-weight: 900;"></i>
                                                                        </button>
                                                                    </div>

                                                                    
                                                                </div>
                                                            </div> -->





                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div id="emptyDeposit2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite" class="spinner">

                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex ; visibility: hidden;  justify-content: center; align-items: center; flex-direction: column; width: 100%;" id="emptyDeposit">
                                            <p class="hp-badge-text">No earnings yet...</p>
                                        </div>


                                    </div>

                                    <!-- WITHDRAWALS -->
                                    <div class="tab-pane fade" id="withdrawal" role="tabpanel"
                                        aria-labelledby="withdrawal-tab">

                                        <!-- DUPLI -->
                                        <div class="card hp-project-ecommerce-table-card"
                                            style="margin-bottom: 10px; border-radius: 10px;"
                                            v-for="(tran, index) in transListW" :key="'number' + index">
                                            <div class="card-body ">
                                                <div class="row">

                                                    <div class="col-12">

                                                        <div class="row g-32 " v-if="tran.type == 'Withdraw2'">

                                                            <div class="col-12 col-sm-3 ">

                                                                <div class="row gx-8 gy-16">

                                                                    <div
                                                                        style="display: flex; justify-content: flex-start; align-items: flex-start; cursor: pointer;">

                                                                        <div class="col hp-flex-none w-auto">

                                                                            <img :src="tran.profilePic"
                                                                                style="width: 58px; height: 58px;    object-fit: cover; margin-right: 5px;  margin-top: -10px;">
                                                                        </div>


                                                                        <div class="col hp-flex-none w-auto">
                                                                            <!-- <h6 class="mb-4 " style="width: 60%; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ tran.fullname }}</h6> -->
                                                                            <h6 class="mb-4 ">{{ tran.bankName }}</h6>
                                                                            <p
                                                                                class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                                {{ tran.accountNumber }}
                                                                            </p>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4">{{ tran.title }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Title
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 tba">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"><span>&#8358;</span> {{
                                                                            tran.payoutAmountD }} </strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Amount
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-7 col-sm-3">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4 dd-none">{{
                                                                            tran.dateD}}</strong>
                                                                        <strong class="mb-4 mm-none">{{
                                                                            tran.dateFull}}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Date and time
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                            <div class="col-5 col-sm-2">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong v-if="tran.status == 'completed' || tran.status == 'successful'"
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-12 px-24 fw-medium ">
                                                                            Successful </strong>

                                                                        <strong v-else-if="tran.status == 'cancelled'"
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-12 px-24 fw-medium ">
                                                                            Declined</strong>

                                                                        <strong v-else style="font-size: 14px;"
                                                                            class="badge bg-warning-4 hp-bg-dark-warning text-warning border-none w-auto py-12 px-24 fw-medium ">
                                                                            Pending </strong>


                                                                    </div>


                                                                </div>
                                                            </div>



                                                            <!-- <div class="col-6 col-sm-1" >
                                                                <div class="row gx-8 gy-16" >
                                                                    
                                                                    <div class="col hp-flex-none w-auto">
                                                                        <button class="btn btn-icon-only rounded-circle btn-outline-primary" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#info">
                                                                            <i class="hp-text-color-dark-0 ri-2 ri-more-line" style="font-size: 24px; font-weight: 900;"></i>
                                                                        </button>
                                                                    </div>

                                                                    
                                                                </div>
                                                            </div> -->





                                                        </div>

                                                    </div>

                                                </div>


                                            </div>



                                        </div>

                                        <div id="emptyWithdraw2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite2" class="spinner">
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex ; visibility: hidden;  justify-content: center; align-items: center; flex-direction: column; width: 100%;" id="emptyWithdraw">
                                            <p class="hp-badge-text">No withdrawals yet...</p>
                                        </div>

                                    </div>
                                </div>

                            </div>


                        </div>

                    </div>

                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>


    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px"
                width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z">
                    </path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- INFO -->
    <div class="modal fade" id="info" tabindex="-1" aria-labelledby="infoLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Transaction details</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -20px;">

                    <div class="mb-24" style="margin-top: 10px;">

                        <p class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30"> Transaction Id </p>
                        <h6 style="margin-top: 10px;">FB4353454543</h6>
                        <div class="divider mt-18 mb-16"></div>
                    </div>

                    <div class="mb-24" style="margin-top: 10px;">

                        <p class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30"> Transaction type </p>
                        <h6 style="margin-top: 10px;">Deposit</h6>
                        <div class="divider mt-18 mb-16"></div>
                    </div>

                    <div class="mb-24" style="margin-top: 10px;">

                        <p class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30"> Transaction title </p>
                        <h6 style="margin-top: 10px;">Subscribe</h6>
                        <div class="divider mt-18 mb-16"></div>
                    </div>

                    <div class="mb-24" style="margin-top: 10px;">

                        <p class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30"> Description </p>
                        <h6 style="margin-top: 10px;">Subscribe to Jane Audrey for 1 month</h6>
                        <div class="divider mt-18 mb-16"></div>
                    </div>

                    <div class="mb-24" style="margin-top: 10px;">

                        <p class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30"> Description </p>
                        <h6 style="margin-top: 10px;">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Modi
                            placeat nam saepe voluptatem perspiciatis, ad voluptate error ipsum eligendi qui.</h6>
                        <div class="divider mt-18 mb-16"></div>
                    </div>



                    <div class="mb-24" style="margin-top: 10px;">

                        <p class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30"> Amount </p>
                        <h6 style="margin-top: 10px;">₦ 10,000</h6>
                        <div class="divider mt-18 mb-16"></div>
                    </div>

                    <div class="mb-24" style="margin-top: 10px;">

                        <p class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30"> Payment method </p>
                        <h6 style="margin-top: 10px;">Card</h6>
                        <div class="divider mt-18 mb-16"></div>
                    </div>

                    <div class="mb-24" style="margin-top: 10px;">

                        <p class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30"> Date </p>
                        <h6 style="margin-top: 10px;">aaaaaaa aaaaaaaa aaaaaaaaaaaaaa</h6>
                        <div class="divider mt-18 mb-16"></div>
                    </div>


                </div>


            </div>
        </div>
    </div>

    <!-- WITHDRAW -->
    <div class="modal fade" id="withdraw" tabindex="-1" aria-labelledby="withdrawLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Withdraw Earnings</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <form @submit.prevent="withdraw">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Amount</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                <input type="number" class="form-control" placeholder="0.00" aria-label="Username"
                                    aria-describedby="basic-addon1" :value="withdrawAmount" disabled>

                            </div>
                            <p class="hp-p2-body" style="margin-top: -10px; font-size: 12px;">Kindly note that a service
                                charge of <strong>&#8358;{{ serviceCharge }}</strong> will be used to process this
                                transaction </p>

                        </div>

                        <div class="mb-24" style="position: relative; margin-top: 30px;">

                            <label class="form-label">Bank name</label>

                            <div class="col-12 col-lg-12" @click="bankOpen">
                                <div class="hp-select-box-item">
                                    <input type="radio" hidden="" id="select-box-logo-item-9" name="select-box-item-9">
                                    <label for="select-box-logo-item-3" class="d-block hp-cursor-pointer">
                                        <div class="card">
                                            <div class="card-body" style="padding: 10px;">
                                                <div class="row justify-content-between ">
                                                    <div class="col-12 ">
                                                        <div class="d-flex justify-content-start align-items-center"
                                                            style="align-items: center;">
                                                            <img :src="bankImage" alt=""
                                                                style="width: 30px; height: 30px; margin-right: 10px; margin-left: 5px;">
                                                            <span class="hp-p1-body"> {{ bankName }} </span>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>


                        </div>

                        <div class="mb-24">
                            <label for="exampleInputEmail1" class="form-label">Account name</label>
                            <input type="text" class="form-control" aria-describedby="emailHelp"
                                placeholder="e.g John Mark Smith" v-model="accountName" required>

                        </div>

                        <div class="mb-24">
                            <label for="exampleInputEmail1" class="form-label">Account number</label>
                            <input type="number" class="form-control" aria-describedby="emailHelp"
                                placeholder="e.g 6320655784" v-model="accountNumber" required>

                        </div>


                        <div class="divider mt-18 mb-16"></div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Proceed</button>
                        </div>

                    </form>

                </div>

            </div>
        </div>
    </div>

    <!-- FUND -->
    <div class="modal fade" id="addFunds" tabindex="-1" aria-labelledby="addFundsLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="exampleModalLabel">Fund Wallet</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="mb-24">
                        <label for="exampleInputEmail1" class="form-label">Payment method</label>
                        <!-- <select class="form-select"  aria-label="Default select example" v-model="paymentMethod">
                            <option value="fiat">Fiat</option>
                            <option value="crypto">Cryptocurrency</option>
                        </select> -->

                        <div class="row g-16">

                            <div class="col-6 col-lg-6">
                                <div class="hp-select-box-item">
                                    <input type="radio" hidden="" value="fiat" id="select-pay-logo-item-1"
                                        name="select-pay-item" v-model="paymentMethod">
                                    <label for="select-pay-logo-item-1" class="d-block hp-cursor-pointer">
                                        <div class="card">
                                            <div class="card-body" style="padding: 20px 5px 10px 5px;">
                                                <div class="row justify-content-between ">
                                                    <div class="col-12 ">
                                                        <div class="d-flex justify-content-center align-items-center"
                                                            style="align-items: center; flex-direction: column;">
                                                            <i class="hp-text-color-dark-0 ri-2x ri-bank-line"></i>
                                                            <p class="hp-p1-body">Pay with Bank</p>
                                                        </div>
                                                    </div>




                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div class="col-6 col-lg-6">
                                <div class="hp-select-box-item">
                                    <input type="radio" hidden="" value="crypto" id="select-pay-logo-item-2"
                                        name="select-pay-item" v-model="paymentMethod">
                                    <label for="select-pay-logo-item-2" class="d-block hp-cursor-pointer">
                                        <div class="card">
                                            <div class="card-body" style="padding: 20px 5px 10px 5px;">
                                                <div class="row justify-content-between ">
                                                    <div class="col-12 ">
                                                        <div class="d-flex justify-content-center align-items-center"
                                                            style="align-items: center; flex-direction: column;">
                                                            <i class="hp-text-color-dark-0 ri-2x ri-bit-coin-line"></i>
                                                            <p class="hp-p1-body">Pay with Crypto</p>
                                                        </div>
                                                    </div>




                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>



                        </div>

                    </div>

                    <div class="mb-24" v-if="paymentMethod == 'crypto'">

                        <div class="row g-16">

                            <div class="col-12 col-lg-12">
                                <div @click="coinOpen" style="width: 100%; border-radius: 10px; border-width: 1px; border-style: dashed; border-color: #bdc7cb; padding: 5px 5px 5px 30px; cursor: pointer;">

                                    <div style="display: flex; justify-content: flex-start; align-items: center;">

                                        <div class="avatar-group" style="margin-right: 20px;">
                                            <div class="avatar-ite d-flex align-items-center justify-content-center  hp-text-color-primary-1 ">
                                                <img :src="coinImage" alt="User" style="width: 120px;" id="coinImage">
                                            </div>
                                        
                                        </div>

                                        <span class="hp-p1-body">{{ coinName }}</span>

                                        <i class="hp-text-color-dark-0 iconly-Light-ChevronDown" style="margin-left: auto;"></i>
                                    </div>

                                    

                                </div>
                            </div>

                            


                        </div>

                    </div>

                    <div class="mb-24" style="margin-top: 30px;">

                        <label for="displayName" class="form-label">Amount</label>
                        <div class="input-group mb-16">
                            <span class="input-group-text" id="basic-addon1"> &#8358; </span>
                            <input type="number" class="form-control" placeholder="0.00" aria-label="Username"
                                aria-describedby="basic-addon1" v-model="fundAmount" @input="depositServiceCharge">

                        </div>
                        <p class="hp-p2-body" style="margin-top: -10px; font-size: 12px;">Kindly note that a service
                            charge of <strong>&#8358;{{ serviceCharge }}</strong> will be used to process this
                            transaction </p>

                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" @click="addFunds">Proceed</button>
                </div>
            </div>
        </div>
    </div>

    <!-- ADDRESS -->
    <div class="modal fade" id="address" tabindex="-1" aria-labelledby="addressLabel" aria-hidden="true"
        data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Deposit {{ coinList[coin].name }}</h4>
                    <span><img :src="coinList[coin].image" alt="" style="width: 40px; margin-right: 10px;"></span>

                    <!-- <button type="button" class="btn-close"  aria-label="Close"></button> -->
                </div>

                <div class="modal-body" style="margin-top: -20px;">

                    <div class="d-flex justify-content-center align-items-center" style="flex-direction: column;">

                        <img :src="coinList[coin].qrImage" alt=""
                            style="width: 250px; height: 250px; margin-bottom: 20px;">

                        <h3>{{ fundAmountCoin }} {{ coinList[coin].symbol }}</h3>

                        <div class="input-group mb-16" style="margin-top: 10px; ">

                            <input :value="coinList[coin].address" type="text" class="form-control"
                                placeholder="address" disabled
                                style="text-align: center; border: none; margin-right: 10px; font-size: 12px;">
                            <button rel="tooltip" data-bs-toggle="tooltip" title="Copied!"
                                class="btn btn-icon-only rounded-circle btn-outline-primary" @click="copy">
                                <i class="hp-text-color-dark-0  ri-file-copy-line"></i>
                            </button>

                        </div>

                        <p style="margin-top: 20px;" class="hp-p1-body">Only send <strong>{{ coinList[coin].symbol
                                }}</strong> to this address. Sending any other asset to this address may result in the
                            loss of your deposit! Please note that this invoice will expire in 15 minutes</p>



                    </div>





                </div>

                <div class="modal-footer">

                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                        @click="cancelCryptoDeposit">Cancel</button>

                    <button class="btn btn-warning" type="button" disabled>
                        <span class="spinner-grow spinner-grow-sm me-8" role="status" aria-hidden="true"></span>
                        Awaiting payment...
                    </button>

                </div>

            </div>
        </div>
    </div>

    <!-- Paassword and pin -->
    <div class="modal fade" id="password" tabindex="-1" aria-labelledby="withdrawLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title"> Withdrawal Pin </h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body" style="margin-top: -40px;">
                    <p class="hp-p2-body" style="margin-top: -10px; font-size: 12px;">Enter your password along with the
                        Withdrawal pin sent to your email. Remember to check your <strong>SPAM / JUNK</strong> if you do
                        not find the pin in your primary inbox. </p>

                        <div class="divider mt-18 mb-16"></div>

                    <form @submit.prevent="withdraw2">

                        <div class="mb-24">

                            <h1 style="text-align: center; width: 100%;" > &#8358; {{ payoutAmount.toLocaleString("US-us") }}</h1>

                            <div class="d-flex align-items-center justify-content-center psw-pad"
                                style="width: 100%; flex-direction: column;">

                                <div
                                    style="display: flex; justify-content: space-between; width: 100%;align-items: center;">
                                    <p style="text-align: start; width: 100%;" class="hp-badge-text"> Commission </p>

                                    <p style="text-align: end; width: 100%; font-weight: 700;"
                                        class="hp-badge-text text-black-80"> &#8358; {{ commissionAmount.toLocaleString("US-us") }}</p>
                                </div>

                                <div
                                    style="display: flex; justify-content: space-between; width: 100%;align-items: center;">
                                    <p style="text-align: start; width: 100%;" class="hp-badge-text"> Service charge
                                    </p>

                                    <p style="text-align: end; width: 100%; font-weight: 700;"
                                        class="hp-badge-text text-black-80"> &#8358; {{ serviceCharge.toLocaleString("US-us") }}</p>
                                </div>

                            </div>

                        </div>

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Password</label>
                            <input type="password" class="form-control" placeholder="*********" aria-label="Username"
                                aria-describedby="basic-addon1" required v-model="password">

                        </div>

                        <div class="mb-24">
                            <label for="exampleInputEmail1" class="form-label">Pin</label>
                            <VuePincodeInput v-model="pin" :digits="5" success-class="border-2 border-green-400"
                                input-class="" spacing-class="mr-8" autofocus />

                        </div>

                        <div class="divider mt-18 mb-16"></div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>

                    </form>


                </div>




            </div>
        </div>
    </div>

    <!-- Bank list -->
    <div class="modal fade" id="bankModal" tabindex="-1" aria-labelledby="bankModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm" >

            <div class="modal-content" style="border-color: #000; border-width: 2px; border-style: dashed;">
                <div class="modal-header py-16" style="margin-top: 10px;">
                    <h5 class="modal-title" id="createModalLabel" style="text-align: center; width: 100%;">Select bank</h5>
                    <button type="button"
                        class="btn-close hp-bg-none d-flex align-items-center justify-content-center"
                        data-bs-dismiss="modal" aria-label="Close" >
                        <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                    </button>
                </div>
                <div class="col-12" style="padding-left: 20px; padding-right: 20px;">
                    <input type="text" class="form-control" placeholder="Search..." style="margin-bottom: 20px; ">
                </div>

                <div class="divider my-0"></div>

                <div class="modal-body py-18">

                    <div class="row" data-bs-dismiss="modal" style="cursor: pointer;" v-for="bank in bankList" :key="bank.code" @click="bankSelect(bank)">
                        <div class="col-4">
                            <img :src="bank.logo" alt="" style="width: 30px; height: 30px; ">
                        </div>
                        <div class="col-8">
                            <p class="group-text" style="font-size: 14px; text-align: start; margin-left: -50px;"> {{ bank.name }}</p>
                        </div>
                        <div class="col-12">
                            <div class="divider my-4 mb-16"></div>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
    </div>

    <!-- Coin list -->
    <div class="modal fade" id="coinModal" tabindex="-1" aria-labelledby="coinModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm" >

            <div class="modal-content" style="border-color: #000; border-width: 2px; border-style: dashed;">
                <div class="modal-header py-16" style="margin-top: 10px;">
                    <h5 class="modal-title" id="createModalLabel" style="text-align: center; width: 100%;">Select coin</h5>
                    <button type="button"
                        class="btn-close hp-bg-none d-flex align-items-center justify-content-center"
                        data-bs-dismiss="modal" aria-label="Close" >
                        <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                    </button>
                </div>
                <div class="col-12" style="padding-left: 20px; padding-right: 20px;">
                    <input type="text" class="form-control" placeholder="Search..." style="margin-bottom: 20px; ">
                </div>

                <div class="divider my-0"></div>

                <div class="modal-body py-18">

                    <div class="row" data-bs-dismiss="modal" style="cursor: pointer;" v-for="coin in coinList" :key="coin.id" @click="coinSelect(coin)">
                        <div class="col-4">
                            <img :src="coin.image" alt="" style="width: 30px; height: 30px; ">
                        </div>
                        <div class="col-8">
                            <p class="group-text" style="font-size: 14px; text-align: start; margin-left: -50px; margin-top: 3px;"> {{ coin.name }}</p>
                        </div>
                        <div class="col-12">
                            <div class="divider my-4 mb-16"></div>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
    </div>


</template>

<style>
.tba {
    display: flex;
    justify-content: start;
    align-items: flex-start;
}

input.vue-pincode-input {
    border: none;
    text-align: center;
    max-width: 70px;
    min-height: 70px;
    font-size: 35px;
    border: 1px solid #b2bec3;
    border-radius: 6px;
    margin-right: 5px;
}

.border-green-400 {
    border-color: #9146ff;
}

.psw-pad {
    padding-left: 100px;
    padding-right: 100px;
}

.fnds{
    z-index: 99;
}

.pBack1{

    background-image: url(../assets/img/pback5.png);
    background-size: contain;
    object-fit: cover;
    background-position: center;
    border-style: none;

    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

}

@media screen and (max-width: 600px) {

    .psw-pad {
        padding-left: 70px;
        padding-right: 70px;
    }

    .tba {
        display: flex;
        justify-content: end;
        align-items: flex-start;
    }

    input.vue-pincode-input {
        border: none;
        text-align: center;
        max-width: 55px;
        min-height: 65px;
        font-size: 40px;
        border: 1px solid #b2bec3;
        border-radius: 6px;
        margin-right: 5px;
    }

    .fnds{
        z-index: 9;
    }
}
</style>

<script>

import SidebarBody from '@/components/SidebarBody.vue';
import HeaderBody from '@/components/HeaderBody.vue';
import FooterBody from '@/components/FooterBody.vue';
import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
import "../../node_modules/v3-infinite-loading/lib/style.css";
import VuePincodeInput from 'vue3-pincode-input';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential, } from "firebase/auth"
import { db } from '@/firebase';
import axios from 'axios';
import { MD5 } from 'md5-js-tools';

export default {

    components: {
        SidebarBody,
        HeaderBody,
        FooterBody,
        InfiniteLoading,
        VuePincodeInput,
    },

    data() {
        return {

            loadingText: "",
            errorText: "",
            successText: "",

            fullName: "",
            userName: "",
            email: "",
            profilePic: "",
            userType: "",

            balance: "",
            balanceD: "",

            earnings: "",
            earningsD: "",

            tipBalance: "",
            tipBalanceD: "",

            subBalance: "",
            subBalanceD: "",

            ppvBalance: "",
            ppvBalanceD: "",

            transListD: [],
            transListW: [],

            depositCount: 0,
            withdrawCount: 0,
            depositCount2: 0,
            withdrawCount2: 0,
            cryptoCount: 0,

            mId: "",
            mTitle: "",

            paymentMethod: "fiat",
            coin: 0,
            fundAmount: "",
            fundAmountCoin: "",

            nk: "6717WTK-4E9MFTD-H7DF06H-QQP9NP8",

            priceEstimate: 0,

            coinList: [

                {
                    id: 0,
                    name: "Bitcoin",
                    symbol: "BTC",
                    network: "Bitcoin Network",
                    image: "https://www.baesnap.com/images/btc.svg",
                    qrImage: "https://www.baesnap.com/images/btcQR.png",
                    address: "bc1qt5zznklm7r57j7e83l2snzk26pghqeq5e6wpn6",
                    currency: "btc",

                },

                {
                    id: 1,
                    name: "Ethereum",
                    symbol: "ETH",
                    network: "Ethereum Network",
                    image: "https://www.baesnap.com/images/eth.svg",
                    qrImage: "https://www.baesnap.com/img/ethQR.png",
                    address: "0x1a0D1B843FB08Ac516d57947c83B3632bdfA26E5",
                    currency: "eth",

                },

                {
                    id: 2,
                    name: "Tether ( ERC20 )",
                    symbol: "USDT",
                    network: "Ethereum Network",
                    image: "https://www.baesnap.com/images/usdt_eth.svg",
                    qrImage: "https://www.baesnap.com/img/usdtQR.png",
                    address: "0x1a0D1B843FB08Ac516d57947c83B3632bdfA26E5",
                    currency: "usdterc20",

                },

                {
                    id: 3,
                    name: "USDC ( ERC20 )",
                    symbol: "USDC",
                    network: "Ethereum Network",
                    image: "https://www.baesnap.com/images/usdc.svg",
                    qrImage: "https://www.baesnap.com/img/usdtQR.png",
                    address: "0x1a0D1B843FB08Ac516d57947c83B3632bdfA26E5",
                    currency: "usdc",

                },

                {
                    id: 4,
                    name: "Solana",
                    symbol: "SOL",
                    network: "Solana Network",
                    image: "https://www.baesnap.com/images/sol.svg",
                    qrImage: "https://www.baesnap.com/img/usdtQR.png",
                    address: "FpwgkY8BLRy83ge8KS54onzpTsKtPvy6zTA5d8xGdfrK",
                    currency: "sol",

                },

            ],

            coinName: "Select Crypto",
            coinImage: "https://www.baesnap.com/images/cimg.png",
            coinSymbol:"",
            coinCurrency: "",

            cryptoPaymentId: "",
            cryptoPaymentStatus: "",
            intervalId: "",
            count: 0,

            paystackReference: "",
            PSPUKEY: "pk_live_66ee7827fddf4247c5239721e01f16caf8df82d4",

            serviceCharge: 300,

            commision: 0.15,
            commissionAmount: "",
            payoutAmount: "",

            withdrawAmount: "",
            bankName: "Select bank",
            bankImage: "https://nigerianbanks.xyz/logo/moniepoint-mfb-ng.png",
            accountName: "",
            accountNumber: "",

            password: "",
            pin: "",
            verifyPin: "",
            pinExpiry: "",

            bankList: [],

            lastDocSnapshot: null,
            lastDocSnapshot2: null,

        }
    },

    mounted() {

        document.body.style.overflowY = 'scroll';

        document.getElementById("mobileLogo").style.display = 'none';
        document.getElementById("mobileTitle").textContent = 'Earnings';

        

        //$('#address').modal('show');
        this.checkAuth();
        this.getBalance();
        this.getBanks();
        this.getCut();

        //document.getElementById("payoutN").classList.add("active");
        //document.getElementById("payoutN2").classList.add("active");
    },

    methods: {

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            this.$router.go();
        },

        copy() {

            let i = Number(this.coin);
            navigator.clipboard.writeText(String(this.coinList[i].address));

            $('[rel=tooltip]').tooltip();

        },

        async getCut(){
            const userRef = doc(db, "AdminInfo", "info");
            const userSnap = await getDoc(userRef);
            let rc = userSnap.data().cut;
            this.commision = Number(rc) / 100;

        },

        checkAuth(){

            const auth = getAuth();
            if(auth == null){
                this.$router.push({name: 'sign-in'})
            }
        },

        async getBanks() {

            try {
                const response = await axios.get("https://nigerianbanks.xyz");
                this.bankList = response.data;
            }
            catch (error) {
                console.error(error);
            }

        },

        profileClick(userId) {

            const auth = getAuth();

            if (auth.currentUser.uid == userId) {
                this.$router.push({ name: 'profile' });
                return;
            }

            sessionStorage.setItem("otherId", userId);
            this.$router.push({ name: 'other-profile' });
            return;

        },

        async getBalance() {

            this.loadingText = "Loading balance...";
            this.$refs.loadingModal.classList.add("bg-active");

            const auth = getAuth();

            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {

                this.balance = userSnap.data().balance;
                this.earnings = userSnap.data().earnings;
                this.tipBalance = userSnap.data().tipBalance;
                this.subBalance = userSnap.data().subBalance;
                this.ppvBalance = userSnap.data().ppvBalance;
                this.userType = userSnap.data().type;
                this.email = userSnap.data().email;
                this.profilePic = userSnap.data().profilePic;
                this.fullName = userSnap.data().name;
                this.userName = userSnap.data().displayId;


                if (this.balance == 0) {
                    this.balanceD = "0.00";
                }
                else {
                    this.balanceD = Number(userSnap.data().balance).toLocaleString("us-US");
                }

                if (this.earnings == 0) {
                    this.earningsD = "0.00";
                }
                else {
                    this.earningsD = Number(userSnap.data().earnings).toLocaleString("us-US");
                }

                if (this.tipBalance == 0) {
                    this.tipBalanceD = "0.00";
                }
                else {
                    this.tipBalanceD = Number(userSnap.data().tipBalance).toLocaleString("us-US");
                }

                if (this.subBalance == 0) {
                    this.subBalanceD = "0.00";
                }
                else {
                    this.subBalanceD = Number(userSnap.data().subBalance).toLocaleString("us-US");
                }

                if (this.ppvBalance == 0) {
                    this.ppvBalanceD = "0.00";
                }
                else {
                    this.ppvBalanceD = Number(userSnap.data().ppvBalance).toLocaleString("us-US");
                }

                this.$refs.loadingModal.classList.remove("bg-active");

            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

        },

        async getTrans() {

            let res = [];
            
            const auth = getAuth();

            const q = query(collection(db, "UserTrans"), where('userId', '==', auth.currentUser.uid), where('type', '==', "Deposit"), orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot || 0));

            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

            if (res.length > 0){

                querySnapshot.forEach((doc) => {

                    let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                    this.transListD.push({

                            userId: doc.data().userId,
                            profilePic: doc.data().profilePic,
                            fullname: doc.data().fullName,
                            username: doc.data().username,

                            id: doc.id,
                            idD: doc.data().idD,
                            type: doc.data().type,
                            title: doc.data().title,
                            description: doc.data().description,
                            amount: doc.data().amount,
                            amountD: Number(doc.data().amount).toLocaleString("us-US"),
                            method: doc.data().method,
                            status: doc.data().status,
                            dateFull: a2.slice(0, -36),
                            dateD: a2.slice(0, -45),

                        })

                })

            }

            return res.length;

        },

        async getTrans2() {

            let res = [];
            
            const auth = getAuth();

            const q = query(collection(db, "UserTrans"), where('userId', '==', auth.currentUser.uid), where('type', '==', "Withdraw2"), orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot2 || 0));

            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot2 = querySnapshot.docs[querySnapshot.docs.length - 1];

            if (res.length > 0){

                querySnapshot.forEach((doc) => {

                    let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                    this.transListW.push({

                            userId: doc.data().userId,
                            profilePic: doc.data().profilePic,
                            fullname: doc.data().fullName,
                            username: doc.data().username,

                            id: doc.id,
                            idD: doc.data().idD,
                            type: doc.data().type,
                            title: doc.data().title,
                            description: doc.data().description,
                            status: doc.data().status,
                            dateFull: a2.slice(0, -36),
                            dateD: a2.slice(0, -45),

                            payoutAmount: doc.data().payoutAmount,
                            payoutAmountD: Number(doc.data().payoutAmount).toLocaleString("US-us"),
                            commission: doc.data().commision,
                            serviceCharge: doc.data().serviceCharge,
                            withdrawAmount: doc.data().withdrawAmount,

                            bankName: doc.data().bankName,
                            accountName: doc.data().accountName,
                            accountNumber: doc.data().accountNumber,

                        })

                })

            }

            return res.length;

        },

        coinSelect(coin){
            this.coinName = coin.name;
            this.coinImage = coin.image;
            this.coinSymbol = coin.symbol;
            this.coinCurrency = coin.currency;
            this.coin = coin.id
            

            document.getElementById("coinImage").style.width = "35px";
        },

        depositServiceCharge() {
            if (this.fundAmount > 10000) {
                this.serviceCharge = this.fundAmount * 0.03;
            }
            else {
                this.serviceCharge = 300;
            }

            if (this.serviceCharge > 4500) {
                this.serviceCharge = 4500;
            }
        },

        withdrawClick() {
            this.withdrawAmount = this.earnings;

            if (this.withdrawAmount < 10000) {
                this.errorText = "Minimum amount for withdrawal is ₦10,000. You have only earned ₦"+this.earningsD;
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

            if (this.withdrawAmount >= 10000) {
                this.serviceCharge = this.withdrawAmount * 0.03;
            }
            else {
                this.serviceCharge = 300;
            }

            if (this.serviceCharge > 4500) {
                this.serviceCharge = 4500;
            }

            $('#withdraw').modal('show');
        },

        bankOpen(){
            $('#bankModal').modal('show');
        },

        bankClose(){
            $('#bankModal').modal('hide');
        },

        coinOpen(){
            $('#coinModal').modal('show');
        },

        coinClose(){
            $('#coinModal').modal('hide');
        },

        bankSelect(bank){
            this.bankName = bank.name;
            this.bankImage = bank.logo;
        },

        withdrawServiceCharge() {
            if (this.withdrawAmount > 10000) {
                this.serviceCharge = this.withdrawAmount * 0.03;
            }
            else {
                this.serviceCharge = 300;
            }

            if (this.serviceCharge > 4500) {
                this.serviceCharge = 4500;
            }
        },

        async withdraw() {

            this.loadingText = "Creating withdrawal request...";
            this.$refs.loadingModal.classList.add("bg-active");

            if (this.userType != "model") {
                this.errorText = "Only models can make withdrawal requests";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

            if (this.bankName == "Select bank") {
                this.errorText = "Please select your bank";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }



            if (this.withdrawAmount < 10000) {
                this.errorText = "Minimum amount for withdrawal is ₦10,000";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

            if (this.earnings < this.withdrawAmount) {
                this.errorText = "Insufficient earnings. Please top up your account.";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

            this.commissionAmount = this.withdrawAmount * this.commision;

            this.payoutAmount = this.withdrawAmount - (this.commissionAmount + this.serviceCharge);

            //get verify pin
            this.verifyPin = String(Math.floor(Math.random() * 90000) + 10000);
            //get pin expiry
            this.pinExpiry = (new Date().getTime() / (1000 * 60)) + 15;

            //console.log("PIN:"+this.verifyPin)
            axios.post('https://api.baesnap.com/v1/withdraw-mail', {
                toName: this.fullName,
                toEmail: this.email,
                pin: this.verifyPin
            })
                .then(function (response) {
                    console.log(response);
                })

            this.$refs.loadingModal.classList.remove("bg-active");
            $('#password').modal('show');

        },

        withdraw2() {

            this.loadingText = "Submitting withdrawal request...";
            this.$refs.loadingModal.classList.add("bg-active");

            //check expiry
                if(Number(new Date().getTime() / (1000 * 60)) > this.pinExpiry){
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "The pin has expired. Click resend to generate a new pin";  
                    return;
                }

            if (this.pin != this.verifyPin) {
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                this.errorText = "Invalid pin";
                return;
            }

            let passwordHash = MD5.generate(String(this.password));

            const auth = getAuth();

            const user = auth.currentUser;
            const credential = EmailAuthProvider.credential(
                this.email, passwordHash);

            reauthenticateWithCredential(user, credential)
                .then((result) => {
                    //password correct
                    this.uploadWithdraw();
                })
                .catch((error) => {
                    this.errorText = "Invalid password...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                });

        },

        async uploadWithdraw() {

            let earnings, newEarnings;
            const auth = getAuth();

            //update balance
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                earnings = userSnap.data().earnings;
            }

            newEarnings = earnings - this.withdrawAmount;

            await updateDoc(userRef, {
                earnings: newEarnings,
                tipBalance: 0,
                subBalance: 0,
                ppvBalance: 0
            });

            let mSecs = new Date().getTime() / 1000;
            let transSecs = 10000000000 / mSecs

            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdraw2",
                title: "Payout request",
                description: "You requested a withdrawal of ₦ " + this.withdrawAmount,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "pending",

                payoutAmount: this.payoutAmount,
                commission: this.commissionAmount,
                serviceCharge: this.serviceCharge,
                withdrawAmount: this.withdrawAmount,

                bankName: this.bankName,
                accountName: this.accountName,
                accountNumber: this.accountNumber,

                userId: auth.currentUser.uid,
                fullName: this.fullName,
                username: this.userName,
                profilePic: this.bankImage,
                email: this.email,

            });

            //notify admin
            axios.post('https://api.baesnap.com/v1/admin-withdraw-mail', {
                toName: this.fullName,
                toEmail: this.email,
                toUsername: this.userName,
                bankName: this.bankName,
                accountNumber: this.accountNumber,
            })
                .then(function (response) {

                })

            this.successText = "Your withdrawal request is now pending and will be completed as soon as possible.";
            this.$refs.loadingModal.classList.remove("bg-active");
            this.$refs.successModal.classList.add("bg-active");

        },

        async handleInfinite($state) {

                const newPostCount = await this.getTrans();

                if (newPostCount > 0) {
                    //more posts
                    return $state.loaded();
                }

                if (this.transListD.length == 0) {
                    document.getElementById("emptyDeposit").style.display = "flex";
                    document.getElementById("emptyDeposit").style.visibility = "visible";

                }

                //no more posts
                document.getElementById("emptyDeposit2").style.display = "none";

                //no more posts
                return $state.complete();

        },

        async handleInfinite2($state) {

                const newPostCount = await this.getTrans2();

                if (newPostCount > 0) {
                    //more posts
                    return $state.loaded();
                }

                if (this.transListW.length == 0) {
                    document.getElementById("emptyWithdraw").style.display = "flex";
                    document.getElementById("emptyWithdraw").style.visibility = "visible";

                }

                //no more posts
                document.getElementById("emptyWithdraw2").style.display = "none";
                

                //no more posts
                return $state.complete();

        },

    }

}


</script>